
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"DeviceState"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"deviceState"},"name":{"kind":"Name","value":"devicestate_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"device_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alltesta_details"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"device_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"injection_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"analog_signal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"analog_signal_details"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"autosampler"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"autosampler_details"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"autosampler_fraction_collector"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"autosampler_fraction_collector_details"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cromite"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cromite_details"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"detector"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"detector_details"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ethernet_adapter_details"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fraction_collector_valve"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fraction_collector_valve_details"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phase"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pump"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pump_details"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ready"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sample_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sleep_countdown"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"thermostat"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"valve"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"valve_details"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"valve_loop"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"valve_loop_details"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"waste"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"wifi_adapter_details"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":801}};
    doc.loc.source = {"body":"subscription DeviceState($deviceId: String!) {\r    deviceState: devicestate_by_pk(device_id:$deviceId ) {\r        alltesta_details\r        device_id\r        injection_id\r        analog_signal\r        analog_signal_details\r        autosampler\r        autosampler_details\r        autosampler_fraction_collector\r        autosampler_fraction_collector_details\r        cromite\r        cromite_details\r        detector\r        detector_details\r        ethernet_adapter_details\r        fraction_collector_valve\r        fraction_collector_valve_details\r        phase\r        pump\r        pump_details\r        ready\r        sample_id\r        sleep_countdown\r        thermostat\r        valve\r        valve_details\r        valve_loop\r        valve_loop_details\r        waste\r        wifi_adapter_details\r    }\r}\r","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["DeviceState"] = oneQuery(doc, "DeviceState");
        
